import { Button } from "antd";
import { useUnmerge } from "utils/useUnmerge";
import type { ExistingPatient } from "../existingPatient";
import type { NiceModalHandler } from "@ebay/nice-modal-react";

interface UnmergeButtonProps {
    readonly modal: NiceModalHandler;
    readonly existingPrp: ExistingPatient;
}

/** Button to trigger un-merge functionality (only used in test environments). */
export const UnmergeButton = ({ modal, existingPrp }: UnmergeButtonProps) => {
    const unmerge = useUnmerge(existingPrp, () => void modal.hide());

    return unmerge ? (
        <Button type="dashed" style={{ margin: "1rem" }} onClick={() => void unmerge()}>
            Unmerge
        </Button>
    ) : null;
};
